module.exports = __webpack_public_path__ + "static/img/logo_ico.bdafd2e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/chaoxinxing/logo_ico.svg
// module id = 1874
// module chunks = 0